'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function TerminiCondizioniPage() {
  return (
    <>
      <Header lang="it" />
      <main style={{ background: '#071520', minHeight: '100vh' }}>
        {/* Hero */}
        <section
          style={{
            background: 'linear-gradient(180deg, #0B1F2E 0%, #071520 100%)',
            borderBottom: '1px solid rgba(240,247,255,0.06)',
            padding: '64px 0 48px',
          }}
        >
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#00D4FF', marginBottom: '12px' }}>
              Documenti legali
            </p>
            <h1
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(28px, 5vw, 44px)',
                fontWeight: 700,
                color: '#F0F7FF',
                lineHeight: 1.2,
                marginBottom: '16px',
              }}
            >
              Termini e Condizioni
            </h1>
            <p style={{ fontSize: '15px', color: 'rgba(240,247,255,0.5)', lineHeight: 1.7 }}>
              Ultimo aggiornamento: aprile 2025
            </p>
          </div>
        </section>

        {/* Content */}
        <section style={{ padding: '56px 0 80px' }}>
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>

              {/* Intro */}
              <LegalSection title="Introduzione">
                <p>
                  Benvenuto su E-Foil Experience. Leggendo queste condizioni, troverai tutto quello che devi sapere prima di prenotare e partecipare a una nostra esperienza.
                </p>
                <p>
                  Ti chiediamo di leggerle con attenzione: sono scritte in modo chiaro e diretto, senza tecnicismi inutili. Prenotando un'esperienza, accetti integralmente quanto indicato di seguito.
                </p>
              </LegalSection>

              {/* Dati professionista */}
              <LegalSection title="Dati del professionista">
                <InfoGrid items={[
                  { label: 'Titolare', value: 'Federico De Nigris' },
                  { label: 'Partita IVA', value: '02812640031' },
                  { label: 'Sede legale', value: 'Via Vincenzo Bellini 3' },
                  { label: 'Email', value: 'info@e-foilexperience.com' },
                ]} />
              </LegalSection>

              {/* Oggetto del servizio */}
              <LegalSection title="Oggetto del servizio">
                <p>
                  E-Foil Experience offre esperienze e lezioni di e-foil sul Lago Maggiore. Ogni sessione include un briefing iniziale, l'attrezzatura di sicurezza obbligatoria e l'assistenza di un istruttore qualificato per tutta la durata dell'attività.
                </p>
                <p>
                  Il servizio è legato a una data e a un orario specifici, concordati al momento della prenotazione. Non si tratta di un servizio continuativo o a disponibilità libera.
                </p>
              </LegalSection>

              {/* Prenotazione e pagamento */}
              <LegalSection title="Prenotazione e pagamento">
                <p>
                  La prenotazione si effettua online tramite il sito ufficiale. Il pagamento è richiesto <strong style={{ color: '#F0F7FF' }}>integralmente al momento della prenotazione</strong>: solo dopo il pagamento la data e l'orario scelti vengono confermati e riservati.
                </p>
                <p>
                  Il pagamento garantisce la riserva dello slot selezionato, che non sarà più disponibile per altri clienti.
                </p>
                <p>
                  I pagamenti vengono elaborati in modo sicuro tramite sistemi di pagamento certificati. E-Foil Experience non conserva i dati della carta di credito.
                </p>
                <p>
                  La prenotazione è personale e non cedibile a terzi senza autorizzazione scritta.
                </p>
              </LegalSection>

              {/* Requisiti di partecipazione */}
              <LegalSection title="Requisiti di partecipazione">
                <p>Per partecipare è necessario rispettare i seguenti requisiti:</p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Età minima: 16 anni compiuti',
                    'I partecipanti minorenni devono essere accompagnati da un genitore o tutore legale, che dovrà firmare il modulo di consenso',
                    'Saper nuotare è obbligatorio',
                    'Peso massimo: 110 kg',
                    'Assenza di condizioni fisiche o mediche che possano compromettere la sicurezza in acqua',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  In caso di dubbi sulle proprie condizioni di salute, è consigliabile consultare un medico prima di partecipare. E-Foil Experience si riserva il diritto di non consentire la partecipazione a chi non soddisfa i requisiti indicati.
                </p>
              </LegalSection>

              {/* Sicurezza e comportamento */}
              <LegalSection title="Sicurezza e comportamento">
                <p>
                  La sicurezza è la nostra priorità assoluta. Prima di ogni sessione viene svolto un briefing obbligatorio durante il quale l'istruttore illustra le norme di sicurezza, l'utilizzo dell'attrezzatura e le regole di comportamento in acqua.
                </p>
                <p>
                  Il partecipante si impegna a:
                </p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Seguire le istruzioni dell\'istruttore in ogni momento',
                    'Indossare l\'attrezzatura di sicurezza fornita (giubbotto, casco)',
                    'Non partecipare sotto l\'effetto di alcol o sostanze',
                    'Segnalare eventuali problemi fisici prima dell\'inizio',
                    'Rispettare le aree di navigazione indicate',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </LegalSection>

              {/* Cancellazioni e modifiche */}
              <LegalSection title="Cancellazioni e modifiche">
                <p>
                  Comprendiamo che i piani possono cambiare. Per questo motivo abbiamo definito una politica di cancellazione chiara e trasparente:
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', margin: '8px 0' }}>
                  <PolicyCard
                    icon="✅"
                    title="Cancellazione con almeno 48 ore di anticipo"
                    description="Rimborso completo dell'importo pagato, effettuato tramite lo stesso metodo di pagamento utilizzato al momento della prenotazione, entro tempi tecnici ragionevoli."
                    positive
                  />
                  <PolicyCard
                    icon="❌"
                    title="Cancellazione entro le 48 ore"
                    description="Nessun rimborso è previsto. L'importo pagato non viene restituito né convertito automaticamente in voucher."
                  />
                </div>
                <p>
                  Le richieste di cancellazione devono essere inviate via email a <a href="mailto:info@e-foilexperience.com" style={{ color: '#00D4FF' }}>info@e-foilexperience.com</a>. Fa fede la data e l'ora di ricezione dell'email.
                </p>
                <p>
                  Per modificare la data o l'orario di una prenotazione, contattaci almeno 48 ore prima. Le modifiche sono soggette a disponibilità e non sono garantite.
                </p>
              </LegalSection>

              {/* Ritardi e no-show */}
              <LegalSection title="Ritardi e no-show">
                <p>
                  La puntualità è fondamentale per garantire un'esperienza ottimale a tutti i partecipanti. Ti chiediamo di arrivare almeno <strong style={{ color: '#F0F7FF' }}>15 minuti prima</strong> dell'orario concordato per il check-in e il briefing.
                </p>
                <p>
                  In caso di ritardo significativo che comprometta lo svolgimento dell'attività, l'esperienza potrebbe non poter essere erogata. In tal caso, l'importo pagato non sarà rimborsato.
                </p>
                <p>
                  In caso di mancata presentazione (no-show), l'importo pagato è perso integralmente e la prenotazione è considerata non utilizzata.
                </p>
              </LegalSection>

              {/* Meteo e condizioni di sicurezza */}
              <LegalSection title="Meteo e condizioni di sicurezza">
                <p>
                  L'e-foil è un'attività outdoor che dipende dalle condizioni meteorologiche e lacustri. La sicurezza dei partecipanti viene sempre messa al primo posto.
                </p>
                <p>
                  In caso di condizioni non idonee allo svolgimento dell'attività — come vento forte, temporali, visibilità ridotta o mare mosso — la valutazione spetta esclusivamente all'organizzazione, che si riserva il diritto di:
                </p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Riprogrammare l\'esperienza a una data alternativa concordata',
                    'Convertire l\'importo in un voucher valido per una sessione futura',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  Il rimborso in denaro per motivi meteo non è garantito. La valutazione finale spetta all'organizzazione, sulla base delle condizioni di sicurezza e dell'esperienza operativa.
                </p>
              </LegalSection>

              {/* Voucher e riprogrammazione */}
              <LegalSection title="Voucher e riprogrammazione">
                <p>
                  I voucher emessi in sostituzione di sessioni annullate per meteo o cause di forza maggiore sono validi per la stagione in corso o per quella successiva, salvo diversa indicazione.
                </p>
                <p>
                  I voucher non sono rimborsabili in denaro e non sono cedibili a terzi senza autorizzazione scritta.
                </p>
              </LegalSection>

              {/* Limitazioni e diritto di rifiuto */}
              <LegalSection title="Limitazioni e diritto di rifiuto">
                <p>
                  E-Foil Experience si riserva il diritto di rifiutare o interrompere la partecipazione di chiunque:
                </p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Non soddisfi i requisiti di partecipazione',
                    'Si presenti in stato di alterazione da alcol o sostanze',
                    'Mostri un comportamento non idoneo o pericoloso per sé o per gli altri',
                    'Non segua le istruzioni dell\'istruttore',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  In questi casi, l'importo pagato non sarà rimborsato.
                </p>
              </LegalSection>

              {/* Responsabilità del cliente */}
              <LegalSection title="Responsabilità del cliente">
                <p>
                  Il partecipante è responsabile di fornire informazioni veritiere al momento della prenotazione e di comunicare eventuali condizioni fisiche rilevanti prima dell'inizio dell'attività.
                </p>
                <p>
                  Partecipando all'esperienza, il cliente dichiara di essere consapevole della natura sportiva e outdoor dell'attività e di accettare i rischi residui connessi, nel rispetto delle norme di sicurezza fornite.
                </p>
                <p>
                  E-Foil Experience non è responsabile per danni, perdita o furto di oggetti personali portati durante l'attività.
                </p>
              </LegalSection>

              {/* Privacy */}
              <LegalSection title="Privacy">
                <p>
                  I dati personali forniti al momento della prenotazione sono trattati nel rispetto del Regolamento UE 2016/679 (GDPR). Per informazioni dettagliate, consulta la nostra{' '}
                  <Link href="/it/privacy-policy" style={{ color: '#00D4FF' }}>Privacy Policy</Link>.
                </p>
              </LegalSection>

              {/* Diritto di recesso */}
              <LegalSection title="Diritto di recesso">
                <p>
                  Trattandosi di un servizio legato a una data e a un orario specifici, non è previsto il diritto di recesso ai sensi della normativa applicabile ai servizi del tempo libero.
                </p>
              </LegalSection>

              {/* Contatti */}
              <LegalSection title="Contatti">
                <p>Per qualsiasi domanda relativa a questi Termini e Condizioni, puoi contattarci:</p>
                <InfoGrid items={[
                  { label: 'Email', value: 'info@e-foilexperience.com' },
                  { label: 'Titolare', value: 'Federico De Nigris' },
                  { label: 'P.IVA', value: '02812640031' },
                ]} />
              </LegalSection>

            </div>
          </div>
        </section>
      </main>
      <Footer lang="it" />
    </>
  );
}

function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2
        style={{
          fontFamily: 'Fraunces, Georgia, serif',
          fontSize: '22px',
          fontWeight: 700,
          color: '#F0F7FF',
          marginBottom: '20px',
          paddingBottom: '12px',
          borderBottom: '1px solid rgba(240,247,255,0.08)',
        }}
      >
        {title}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {children}
      </div>
    </div>
  );
}

function InfoGrid({ items }: { items: { label: string; value: string }[] }) {
  return (
    <div
      style={{
        background: 'rgba(240,247,255,0.03)',
        border: '1px solid rgba(240,247,255,0.08)',
        borderRadius: '12px',
        padding: '20px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      {items.map((item) => (
        <div key={item.label} style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', fontWeight: 700, color: 'rgba(240,247,255,0.4)', minWidth: '100px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            {item.label}
          </span>
          <span style={{ fontSize: '14px', color: 'rgba(240,247,255,0.8)' }}>{item.value}</span>
        </div>
      ))}
    </div>
  );
}

function PolicyCard({ icon, title, description, positive }: { icon: string; title: string; description: string; positive?: boolean }) {
  return (
    <div
      style={{
        background: positive ? 'rgba(0, 212, 100, 0.05)' : 'rgba(255, 80, 80, 0.05)',
        border: `1px solid ${positive ? 'rgba(0, 212, 100, 0.15)' : 'rgba(255, 80, 80, 0.15)'}`,
        borderRadius: '10px',
        padding: '16px 20px',
        display: 'flex',
        gap: '14px',
        alignItems: 'flex-start',
      }}
    >
      <span style={{ fontSize: '18px', flexShrink: 0 }}>{icon}</span>
      <div>
        <p style={{ fontSize: '14px', fontWeight: 700, color: '#F0F7FF', marginBottom: '4px' }}>{title}</p>
        <p style={{ fontSize: '14px', color: 'rgba(240,247,255,0.65)', lineHeight: 1.6 }}>{description}</p>
      </div>
    </div>
  );
}
